/*jslint browser: true */
/*global window */

(function($){

	$('.scrollDown').on('click', function(){
		$('html, body').animate(
			{ scrollTop: $("#contact-form").offset().top }, 1000
		);
	})

	// $('.joinDirectory').on('click', function(){
	// 	$('html, body').animate(
	// 		{ scrollTop: $("#creative-driectory-sign-up").offset().top }, 1000
	// 	);
	// })

	// Smooth Scroll

	// $(document).on('click', 'a[href^="#"]', function (event) {
	// 	event.preventDefault();

	// 	$('html, body').animate({
	// 		scrollTop: $($.attr(this, 'href')).offset().top - 100
	// 	}, 500);
	// });

	$('.mobile-search-cta').on('click', function(){
		$('.mobile_menu').removeClass('active');
		$('.header-menu').removeClass('open');
	});

	// Header icon
	var svgCode = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>';
	$('.nav-search').prepend(svgCode);

	$(document).ready(function(){
		let testPresent = $('.testimonials-slider')
		if (testPresent.length > 0) {
			$('.testimonials-slider').slick({
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				dots: true,
				mobileFirst: false,
				rows: 0,
				responsive: [
					{
						breakpoint: 819,
						settings: {
							slidesToShow: 1	
						}
						
					},
					{
						breakpoint : 1023,
						settings: {
							slidesToShow: 2	
						}
					}
				]
			})	
		}

		let postSlider = $('.post-grid-slider')
		if (postSlider.length > 0) {
			var $window = $(window);
			var settings = {
				infinite: true,
				arrows: false,
				dots: true,
				centerMode: true,
				variableWidth: true,
				rows: 0,
			};
			if ($window.width() >= 820) {
				postSlider.slick(settings);
			}

			$window.on('resize', function() {
			  if ($window.width() < 820) {
			    if (postSlider.hasClass('slick-initialized'))
			      postSlider.slick('unslick');
			    return
			  }
			  if ( ! postSlider.hasClass('slick-initialized'))
			    return postSlider.slick(settings);
			}); 
		}

		$('.gallery-item').featherlightGallery({
			previousIcon: '&lsaquo;',     /* Code that is used as previous icon */
			nextIcon: '&rsaquo;',
		});
		
	})

	$('#post-filter-form').on('submit', function(e){
		e.preventDefault()
	})


	$.fn.isInViewport = function() {
	    var elementTop = $(this).offset().top;
	    var elementBottom = elementTop + $(this).outerHeight();

	    var viewportTop = $(window).scrollTop();
	    var viewportBottom = viewportTop + $(window).height();

	    return elementBottom > viewportTop && elementTop < viewportBottom;
	};

	$(window).on('resize scroll load', function() {
		let statCheck = $('.statistics')
	    if (statCheck.length > 0 && $('.statistics').isInViewport()) {
	        runAnimations()
	        $('.statistics').removeClass('statistics')
	    }
	});

	// var input = document.getElementById( 'cdf-image' )
	// if (input !== null) {
	// 	console.log('Loaded');
	// 	var infoName = document.querySelector( '.file-info-name' )
	// 	var infoArea = document.querySelector( '.file-info' )

	// 	input.addEventListener( 'change', showFileName )

	// 	function showFileName( event ) {
	// 		var input = event.srcElement
	// 		var fileName = input.files[0].name
	// 		infoName.textContent = 'File name: ' + fileName
	// 		infoArea.style.display = "flex"
	// 	}

	// 	let clearFile = document.querySelector('.file-clear')
	// 	clearFile.addEventListener('click', clearFileInput)
	// 	function clearFileInput() {
	// 		input.value = ''
	// 		infoArea.style.display = "none"
	// 	}
	// }
		
	

	const animationDuration = 2000
	const frameDuration = 1000 / 60
	const totalFrames = Math.round( animationDuration / frameDuration )
	const easeOutQuad = t => t * ( 2 - t )

	const animateCountUp = el => {
		let frame = 0
		const countTo = parseInt( el.innerHTML, 10 )
	  	const counter = setInterval( () => {
			frame++
			const progress = easeOutQuad( frame / totalFrames )
			const currentCount = Math.round( countTo * progress )

			if ( parseInt( el.innerHTML, 10 ) !== currentCount ) { el.innerHTML = currentCount }
			if ( frame === totalFrames ) { clearInterval( counter ) }
		}, frameDuration )
	};

	const runAnimations = () => {
		const countupEls = document.querySelectorAll( '.countup' )
		countupEls.forEach( animateCountUp )
	};


	$(document).ready(function() {
		$('.scroll-row').on('mousedown', function (event) {
		  	$(this)
				.data('down', true)
				.data('x', event.clientX)
				.data('scrollLeft', this.scrollLeft)
				.addClass("dragging");
		  	return false;
		})
		$('.scroll-row').on('mouseup', function (event) {
		  	$(this).data('down', false).removeClass("dragging");
		})
		$('.scroll-row').on('mousemove', function (event) {
		  	if ($(this).data('down') == true) {
		      	this.scrollLeft = $(this).data('scrollLeft') + $(this).data('x') - event.clientX;
		  	}
		})
		$('.scroll-row').on('mousewheel', function (event, delta) {
		  	this.scrollLeft -= (delta * 30);
		})
		$('.scroll-row').css({
		  	// 'overflow' : 'hidden',
		  	'cursor' : '-moz-grab'
		});
		

		let mobileLinks = $('#offcanvas-nav a')
		mobileLinks.each(function (i) { 
			$(this).attr('tabindex', -1);
		});
    });

	$('.icon-gallery-set-item-second img').on('click', function(){
		$(this).next().addClass('active')
	})
	$('.icon-gallery-set-item-text-close').on('click', function(){
		$('.icon-gallery-set-item-text').removeClass('active')	
	})


	// Creative directory
	
	$('.selection').on('click', function(){
		$(this).siblings('ul').slideToggle();
	});
	// Creative Discipline
	$('.dropdown-wrap.tag-select ul li').on('click', function(){
		let name = $(this).text();
		let id = $(this).attr('data-id');
		let dropdownWrap = $(this).closest('.dropdown-wrap');
		let matchFound = false;
		let isPrimary = false;
		if ($(this).closest('.cell').hasClass('primary-discipline')) {
			isPrimary = true;
		}
		console.log(isPrimary);
		if (dropdownWrap.find('.selection-item').length) {
			dropdownWrap.find('.selection-item').each(function(){
				 if ($(this).attr('data-id') == id) {
					  matchFound = true;
				 }
			});
		}
		if (!matchFound) {
			if(!isPrimary && dropdownWrap.find('.selection-item').length < 4){
				$(this).parent().siblings().append('<div class="selection-item" data-id="'+ id + '">*'+ name +'*<span>x</span></div>');
			} else {
				if (dropdownWrap.find('.selection-item').length < 1) {
					$(this).parent().siblings().append('<div class="selection-item" data-id="'+ id + '">*'+ name +'*<span>x</span></div>');
					$('#cdf-primary-discipline-id').attr('value', id);
					$('#cdf-primary-discipline').attr('value', name);
				}
			}
		}
		$(this).parent().slideUp();
	});
	$('.dropdown-wrap.tag-select .selection').on('click', '.selection-item',  function(e){
		e.stopPropagation();
		$(this).closest('.dropdown-wrap').siblings('input').val('');
		$(this).remove();
	})

	// Creative Discipline
	$('.socials-wrap .dropdown-wrap ul li').on('click', function(){
		let name = $(this).text();
		let socialType = $(this).attr('data-social-type');
		let inputType = $(this).attr('data-input-type');
		$(this).parent().siblings().find('.selection-item').attr('data-social-type', socialType);
		$(this).parent().siblings().find('.selection-item').text(name);
		$(this).closest('.dropdown-wrap').siblings('input').attr('type', inputType);
		$(this).parent().slideUp();
	});

	// social links 
	$('.social-item .add').on('click', function(){
		$(this).closest('.social-item').siblings('.hidden').first().removeClass('hidden');
  });

	$('.social-item .minus').on('click', function(){
		let parent = $(this).parent().find('.selection-item');
		let input = $(this).parent().find('input');
		parent.text('Website');
		parent.attr('data-social-type', '');
		input.val('');
		$(this).parent().addClass('hidden');
		$()
	});

	// experience checkboxes
	var maxAllowed = 3;

	$('.experience-wrap label input[type="checkbox"]').on('change', function() {
		 var checkedCheckboxes = $('.experience-wrap label input[type="checkbox"]:checked');
		 if (checkedCheckboxes.length > maxAllowed) {
			  $(this).prop('checked', false);
		 }
	});

	$('input[name="cdf-profile-type"]').on('change', function(){
		let checkedInput = $('input[name="cdf-profile-type"]:checked');

		if (checkedInput.attr('id') == 'individual') {
			$('.profile-title').text('Tell us about you');
			$('.profile-name').text('Your name');
		}
		if (checkedInput.attr('id') == 'business-organisation') {
			$('.profile-title').text('Tell us about your business');
			$('.profile-name').text('Business/Organisation Name');
		}
	});

	// character counts

	$('#cdf-excerpt').on('input', updateCharacterCount);
	$('#cdf-excerpt').on('focus', showCharCount);

	function updateCharacterCount() {
		var maxLength = 300;
		var remainingChars = maxLength - $(this).val().length;
		$('#charCount').text(remainingChars + ' characters remaining');

		if (remainingChars <= 0) {
			$(this).attr('maxlength', $(this).val().length);
	  } else {
			$(this).removeAttr('maxlength');
	  }
  }
  
  function showCharCount() {
		$('#charCount').css('display', 'block');
  }

	// View more 
	$('.view-more').on('click', function(){
		$(this).closest('.directory-grid-item-post').siblings('.shadow-item').removeClass('hidden');
	});
	$('.view-less').on('click', function(){
		$(this).parent('.shadow-item').addClass('hidden');
	});

	$(document).on("sf:ajaxfinish", ".searchandfilter", function(){
		$('.post-filter-count').show();
		$('.view-more').on('click', function(){
			$(this).closest('.directory-grid-item-post').siblings('.shadow-item').removeClass('hidden');
		});
		$('.view-less').on('click', function(){
			$(this).parent('.shadow-item').addClass('hidden');
		});
	});

	$('#creativeDirectoryForm .modal .close-btn, #creativeDirectoryForm .modal').on('click', function(){
		if ($(this).hasClass('update-modal')) {
			// refresh the page
			location.reload();
		} else {
			$('#creativeDirectoryForm .modal').addClass('hidden');
		}
	});


$('.user-account-wrap .panel-buttons button').on('click', function(){
	$('.user-account-wrap .panel-buttons button').removeClass('active');
	let panelId = $(this).attr('data-panel');
	let panel = $('.account-panel-' + panelId);
	$(this).addClass('active');
	$('.account-panel').removeClass('active');
	panel.addClass('active');
});

})(jQuery);



//const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
// 	const { top, left, bottom, right } = el.getBoundingClientRect();
// 	const { innerHeight, innerWidth } = window;
// 	return partiallyVisible
// 		? ((top > 0 && top < innerHeight) ||
// 	    	(bottom > 0 && bottom < innerHeight)) &&
// 	    	((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
// 		: top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
// };

// let statBlock = document.querySelectorAll( '.statistics' );
// console.log(statBlock);
// if (statBlock !== null && statBlock.length > 0) {
// 	console.log('We here!');
// 	if (elementIsVisibleInViewport(statBlock, true)) {
// 		console.log('Found');
// 		runAnimations()
// 	}
// }

	


